import React, { useState } from 'react';
import TippspielConnectionSettings from './admin/TippspielConnectionSettings';
import TippspielScoringSettings from './admin/TippspielScoringSettings';
import TippspielRulesSettings from './admin/TippspielRulesSettings';
import TippspielMatchControl from './admin/TippspielMatchControl';
import TippspielSyncStatus from './admin/TippspielSyncStatus';
import TippspielParticipants from './admin/TippspielParticipants';

const tabs = [
  { id: 'connection', label: 'Verbindung & Projekt' },
  { id: 'scoring', label: 'Punkte' },
  { id: 'rules', label: 'Regeln' },
  { id: 'matches', label: 'Spiele' },
  { id: 'participants', label: 'Teilnehmer' },
  { id: 'sync', label: 'Sync-Log' },
];

const AdminSettings = () => {
  const [active, setActive] = useState('connection');

  const render = () => {
    switch (active) {
      case 'connection': return <TippspielConnectionSettings />;
      case 'scoring': return <TippspielScoringSettings />;
      case 'rules': return <TippspielRulesSettings />;
      case 'matches': return <TippspielMatchControl />;
      case 'participants': return <TippspielParticipants />;
      case 'sync': return <TippspielSyncStatus />;
      default: return <TippspielConnectionSettings />;
    }
  };

  return (
    <div className="admin-theme flex flex-col lg:flex-row gap-6">
      <aside className="lg:w-52 flex-shrink-0">
        <h2 className="section-title mb-4 px-2"><span>Admin</span></h2>
        <ul className="space-y-1">
          {tabs.map((tab) => (
            <li key={tab.id}>
              <button
                type="button"
                onClick={() => setActive(tab.id)}
                className={`w-full text-left px-3 py-2 rounded-xl text-sm font-medium transition-colors ${
                  active === tab.id ? 'nav-link-active' : 'text-white/60 hover:bg-white/5 hover:text-white'
                }`}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </aside>
      <div className="flex-1 min-w-0">{render()}</div>
    </div>
  );
};

export default AdminSettings;
